<template>
	<sf-search-layout>
		<el-row :gutter="20">
			<el-col :span="4">
				<sf-select-group
					:label="getMessage_('SWCC000145')"
					:inputValue="searchParam.useYn"
					:options="useYnSearchOptions"
					:onChange="value => onChange({ key: 'useYn', value })"
				/>
			</el-col>
			<el-col :span="6">
				<sf-input-group
					:label="getMessage_('SWCC000224')"
					:inputValue="searchParam.widgetTitle"
					:onChange="value => onChange({ key: 'widgetTitle', value })"
				/>
			</el-col>
		</el-row>
		<template slot="button">
			<sf-button line :v-if="isButton_(scrId, 'CR')" icon="search" :onClick="search">{{ getButtonMsg_(scrId, 'CR') }}</sf-button>
		</template>
	</sf-search-layout>
</template>

<script>
import { serviceComputed, serviceMethods } from '@common/WidgetMaster/store/helpers';
import { rootComputed } from '@/store/common/helpers';
export default {
	computed: {
		...rootComputed,
		...serviceComputed,
		useYnSearchOptions() {
			return [{ text: 'ALL', value: 'ALL' }, ...this.useYnOptions];
		}
	},
	methods: {
		...serviceMethods,
		search() {
			this.$sf_toggleLoading(true);
			return this.selectWidgetMaster_().finally(() => this.$sf_toggleLoading(false));
		},
		onChange(payload) {
			this.onChangeSearchParam_(payload);
			if (payload.key === 'useYn') {
				this.search();
			}
		}
	},
	mounted() {
		this.$sf_toggleLoading(true);
		Promise.all([this.selectCommCd_('USE_YN'), this.search()]).finally(r => this.$sf_toggleLoading(false));
	},
	data() {
		return {
			useYn: 'Y'
		};
	}
};
</script>
